module.exports = __webpack_public_path__ + "img/anel-townsend.3efde4ef.png";